export const BE = {
    translations: {
        notifications: 'Паведамленнi',
        markAllAsRead: 'Пазначыць усе як прачытаныя',
        poweredBy: 'Пры падтрымцы',
        settings: 'Налады',
        noNewNotification: 'Тут пакуль няма нічога новага',
    },
    lang: 'be',
};
//# sourceMappingURL=be.js.map